import { createRef, Component  } from 'react';
import CreateIcon from "@material-ui/icons/Create";
import { connect } from "react-redux";
import MsaWarning from "../ExtraComponents/MsaWarning";
import SettingsError from "../ExtraComponents/SettingsError";
import { addSettings, addMsaInfo } from "../../../actions";
import { ValidateEmail, normalize } from "../../../config/utility";
import {
  listMySubAgents,
  getMySingleSubAgent,
  editMySubAgent,
  listMySubAgentRoles,
  editMySubAgentRoles,
  sendMySubAgentInvite,
  getMySubAgentInvites,
  deleteMySubAgentInvite,
  getMySubAgentServices,
  updateMySubAgentServices,
  getMySubAgentCommissionAllocation,
  saveMySubAgentCommissionAllocation,
  getMySubAgentLogin,
  listServices,
  getAgentSplit,
  addAgentSplit,
  getAgentPermissionData,
  getRoleFieldSetting,
} from "./../../../config/api_calls";
import HelperClass from "./../../../config/helperClass";
import $ from "jquery";
import DataTable from "../../../components/Tables/DataTable";
import { tableLoader } from "../../../components/ContentLoaders/table_loader";
import { tableLoaderListing } from "../../../components/ContentLoaders/table_loader_listing";
import PageTitle from "../ExtraComponents/PageTitle";
import Typography from "@material-ui/core/Typography";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Link from "@material-ui/core/Link";
import HomeIcon from "@material-ui/icons/Home";
import StepWizard from "react-step-wizard";
import MutextField from "@material-ui/core/TextField";
import { PhoneNumberUtil } from "google-libphonenumber";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import countryList from "react-select-country-list";
import Autocomplete from "@material-ui/lab/Autocomplete";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import PasswordStrengthBar from "react-password-strength-bar";
import { FormLoader } from "../../../components/ContentLoaders/newLoaders/FormLoader";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import dateFormat, { masks } from "dateformat";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import ReactPhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";

const auth = new HelperClass();
class SubAgents extends Component {
  constructor() {
    super();
    this.state = {
      tableData: [],
      // Role is a separate field from Title, shown only when the reseller
      // has enabled it in custom settings.
      role: "",
      role_field_enabled: false,
      servicesData: [],
      splitData: [],
      errorMessage: "",
      agentId: "",
      successMessage: "",
      waitMessage: "",
      tableLoader: true,
      tableLoaderListing: true,
      errorMessageEdit: "",
      successMessageEdit: "",
      title: "",
      name: "",
      agent_email: "",
      agent_phone: "",
      agent_password: "",
      c_password: "",
      agent_id: "",
      sub_agent_id: "",
      formValues: [],
      comp: "",
      city: "",
      state: "",
      zip: "",
      country: "United States",
      address: "",
      address2: "",
      passwordShown: false,
      confirmPasswordShown: false,
      notifyCheckBox: false,
      account_status: "",
      errorMessageAgentRole: "",
      successMessageAgentRole: "",
      assignRoleData: [],
      assignSubRoleData: [],
      changedRolesRights: [],
      changedSubRolesRights: [],
      errorMessageSubAgentRole: "",
      successMessageSubAgentRole: "",
      subassignRoleData: [],
      subassignSubRoleData: [],
      subchangedRolesRights: [],
      subchangedSubRolesRights: [],
      checkedRoleIds: [],
      checkedSubRoleIds: [],
      checkedName: "",
      checkedEmail: "",

      errorName: "",
      errorStatus: "",
      errorAgentCompany: "",
      errorAgentEmail: "",
      errorAgentPhone: "",
      errorAgentAddress: "",
      errorAgentCity: "",
      errorAgentState: "",
      errorAgentZip: "",
      errorAgentCountry: "",
      errorAgentPassword: "",
      errorCPassword: "",
      useGooglePlaces: true,
      toggleButtonText: "Allow PO Box Address",

      errorMessageInvite: "",
      successMessageInvite: "",
      agent_name: "",
      invitation_comment: "",
      tableData_invitedAgents: [],
      activeTabCP: "tabItem7",
      delete_id: "",
      address_autocomplete: true,
      address_validation: true,

      anchorEl: null,
      selectedRowId: null,
      selectedRowStatus: null,
      selectedRowData: null,
      menuType: null,

      // Assign Products modal (catalog = only the Main's active products)
      productsLoader: false,
      productsData: [],
      products_agent_id: "",
      productsAgentName: "",
      errorMessageProducts: "",
      successMessageProducts: "",
      disableProductsBtn: false,
      // Commission Allocation modal (percentage-points of the order total)
      commissionLoader: false,
      commission_agent_id: "",
      commissionAgentName: "",
      commission_percentage: "",
      commission_main_rate: null,
      errorMessageCommission: "",
      successMessageCommission: "",
      disableCommissionBtn: false,

      columnServices: [
        { name: "Date Added" },
        { name: "Company" },
        { name: "Name" },
        { name: "Email" },
        {
          name: "Status",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.setStatus(value, tableMeta)}</div>;
            },
          },
        },
        {
          name: "Action",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return (
                <IconButton
                  size="small"
                  onClick={(event) =>
                    this.handleMenuOpen(
                      event,
                      tableMeta.rowData[5],
                      null,
                      tableMeta.rowData,
                      "agents"
                    )
                  }
                  style={{
                    border: "1px solid #dbdfea",
                    borderRadius: "6px",
                    padding: "6px",
                    backgroundColor: "#fff",
                    outline: "none",
                  }}
                >
                  <MoreHorizIcon fontSize="small" />
                </IconButton>
              );
            },
          },
        },
        { name: "ACCOUNT #", options: { display: false, filter: false } },
        {
          name: "Commission %",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return (
                <div>{value && value !== "" ? value + "%" : "0.00%"}</div>
              );
            },
            filter: false,
          },
        },
        {
          // What the Main keeps on THIS Sub Agent's orders. Blank when the
          // Main's commission is not a percentage of the order total, where
          // the two values are not in the same units.
          name: "Main Keeps %",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{value && value !== "" ? value + "%" : "---"}</div>;
            },
            filter: false,
          },
        },
      ],
      columnServices_invitedAgents: [
        { name: "Sub Agent Name" },
        { name: "Sub Agent Email" },
        {
          name: "Invited On",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.format_date(value)}</div>;
            },
            filter: false,
          },
        },
        { name: "AGENT ID", options: { display: false } },
        { name: "ID", options: { display: false } },
        {
          name: "Comment",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return (
                <div onClick={() => this.assignedTo(value, tableMeta)}>
                  <span
                    className="badge badge-outline-secondary"
                    style={{ cursor: "pointer" }}
                  >
                    View
                  </span>
                </div>
              );
            },
          },
        },
        {
          name: "Link",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              const rowId = tableMeta.rowData[5];
              const textToCopy = tableMeta.rowData[4];
              if (textToCopy && textToCopy.trim() !== "") {
                return (
                  <div
                    onClick={() => this.copyToClipboard(textToCopy, rowId)}
                    style={{ cursor: "pointer" }}
                  >
                    <span className="d-flex align-items-center">
                      <i
                        className={`icon ni ${
                          this.state.copiedRowId === rowId
                            ? "ni-check"
                            : "ni-copy"
                        }`}
                      ></i>
                      <span>
                        {this.state.copiedRowId === rowId ? "Copied" : "Copy"}
                      </span>
                    </span>
                  </div>
                );
              } else {
                return <div>---</div>;
              }
            },
          },
        },
        {
          name: "Actions",
          options: {
            customBodyRender: (value, tableMeta) => {
              return (
                <IconButton
                  size="small"
                  onClick={(event) =>
                    this.handleMenuOpen(
                      event,
                      tableMeta.rowData[5],
                      null,
                      tableMeta.rowData,
                      "invitedAgents"
                    )
                  }
                  style={{
                    border: "1px solid #dbdfea",
                    borderRadius: "6px",
                    padding: "6px",
                    backgroundColor: "#fff",
                    outline: "none",
                  }}
                >
                  <MoreHorizIcon fontSize="small" />
                </IconButton>
              );
            },
          },
        },
      ],
    };
    this.phoneInputRef = createRef();
    this.countryOptions = countryList()
      .getData()
      .filter(
        (country) => country.label !== "United States Minor Outlying Islands"
      )
      .sort((a, b) => {
        if (a.label === "United States") return -1;
        if (b.label === "United States") return 1;
        return a.label.localeCompare(b.label);
      });
  }

  async componentDidMount() {
    await this.loadSubAgents();
    await this.getAgentPermissionData();
    window.addEventListener("scroll", this.handleMenuClose);
  }

  // Extracted from componentDidMount so a save can refresh the listing in place
  // instead of reloading the whole page.
  loadSubAgents = async () => {
    const servicesResponce = await listMySubAgents(
      auth.getAccount(),
      auth.getToken()
    );
    // console.log("sub-agent.data.data: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      // No Sub Agents yet -> standard empty listing.
      this.setState({ tableData: [], tableLoader: false });
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        tableData: servicesResponce.data.data,
        tableLoader: false,
      });
    } else {
      // window.location.replace("/error");
    }
  };

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleMenuClose);
  }

  loadRoleFieldSetting = async () => {
    let enabled = false;
    try {
      const res = await getRoleFieldSetting(auth.getAccount(), auth.getToken());
      enabled = res && res.data && res.data.role_field_enabled ? true : false;
    } catch (error) {
      enabled = false;
    }
    // The Role column is last in the row data; reveal it in place and let
    // columnOrder move it next to Title visually.
    this.setState((prevState) => ({
      role_field_enabled: enabled,
      columnServices: prevState.columnServices.map((col) =>
        col.name === "Role"
          ? { ...col, options: { ...col.options, display: enabled } }
          : col
      ),
    }));
  };

  getAgentPermissionData = async () => {
    let acctno = auth.getAccount();

    let res = await getAgentPermissionData(
      acctno,
      auth.getToken(),
      auth.getEmail()
    );
    //console.log("getAgentPermissionData: ", res.data);
    if (res.data.status === 200 && res.data.message === "success") {
      const permissionData = res.data.agentPermissionSettingsInfo?.data || {};
      this.setState({
        address_autocomplete: permissionData.address_autocomplete,
        address_validation: permissionData.address_validation,
      });
    }
  };

  handleMenuOpen = (event, rowId, status, rowData, menuType) => {
    this.setState({
      anchorEl: event.currentTarget,
      selectedRowId: rowId,
      selectedRowStatus: status,
      selectedRowData: rowData,
      menuType: menuType,
    });
  };

  handleMenuClose = () => {
    this.setState({
      anchorEl: null,
      selectedRowId: null,
      selectedRowStatus: null,
      selectedRowData: null,
      menuType: null,
    });
  };

  phoneUtil = PhoneNumberUtil.getInstance();

  isPhoneValid = (phone) => {
    try {
      return this.phoneUtil.isValidNumber(
        this.phoneUtil.parseAndKeepRawInput(phone)
      );
    } catch (error) {
      return false;
    }
  };

  handleToggle = () => {
    this.setState((prevState) => ({
      useGooglePlaces: !prevState.useGooglePlaces,
      toggleButtonText:
        prevState.toggleButtonText === "Allow PO Box Address"
          ? "Allow Simple Address"
          : "Allow PO Box Address",
    }));
  };

  handleFocus = () => {
    // Move cursor to the end of the input value
    const input = this.phoneInputRef.current;
    if (input) {
      const value = input.value;
      input.setSelectionRange(value.length, value.length);
    }
  };

  handleAddressSelect = async (place) => {
    const { description } = place.value;
    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
          description
        )}&key=${process.env.REACT_APP_ADDRESS_AUTOCOMPLETE_API_KEY}`
      );
      const data = await response.json();

      if (data.status === "OK") {
        const addressComponents = data.results[0].address_components;
        const formattedAddress = data.results[0].formatted_address;
        let city = null;
        let state = null;
        let country = null;
        let zipCode = null;
        let streetAddress = "";
        let neighborhood = null;
        let locality = null;
        let address2 = "";
        addressComponents.forEach((component) => {
          if (component.types.includes("neighborhood")) {
            neighborhood = component.long_name;
          } else if (component.types.includes("locality")) {
            locality = component.long_name;
          } else if (component.types.includes("administrative_area_level_1")) {
            state = component.short_name;
          } else if (component.types.includes("country")) {
            country = component.long_name;
          } else if (component.types.includes("postal_code")) {
            zipCode = component.long_name;
          } else if (component.types.includes("subpremise")) {
            address2 = component.long_name;
          } else if (
            ![
              "neighborhood",
              "sublocality",
              "sublocality_level_1",
              "sublocality_level_2",
              "administrative_area_level_2",
              "administrative_area_level_3",
              "postal_code_suffix",
            ].includes(component.types[0])
          ) {
            if (streetAddress !== "") {
              streetAddress += " ";
            }
            streetAddress += component.long_name;
          }
        });
        // Check if neighborhood is part of the formatted address
        if (neighborhood && formattedAddress.includes(neighborhood)) {
          city = neighborhood;
        } else {
          city = locality;
        }
        this.setState({
          city: city && city !== "" ? city : "",
          state: state && state !== "" ? state : "",
          zip: zipCode && zipCode !== "" ? zipCode : "",
          country: country && country !== "" ? country : "",
          address: streetAddress && streetAddress !== "" ? streetAddress : "",
          address2: address2 && address2 !== "" ? address2 : "",
        });
      } else {
        console.error("Reverse geocoding request failed:", data.status);
      }
    } catch (error) {
      console.error("Error fetching reverse geocoding data:", error);
    }
  };

  togglePassword = () => {
    this.setState({
      passwordShown: !this.state.passwordShown,
    });
  };

  toggleConfirmPassword = () => {
    this.setState({
      confirmPasswordShown: !this.state.confirmPasswordShown,
    });
  };

  subagentAssignRole = async (value, tableMeta) => {
    const agentId = tableMeta.rowData[5];
    const agentEmail = tableMeta.rowData[3];
    this.setState({
      errorMessageAgentRole: "",
      successMessageAgentRole: "",
      assignRoleData: [],
      assignSubRoleData: [],
      changedRolesRights: [],
      changedSubRolesRights: [],
      agentRoleLoader: true,
      disableRoleBtn: false,
      disableSubRoleBtn: false,
      rolesAgentName: tableMeta.rowData[2],
      checkedName: tableMeta.rowData[2],
      checkedEmail: tableMeta.rowData[3],
    });
    window.$("#modalSubAgentAssignRole").modal("show");
    this.getSubAgentRoleData(agentId, agentEmail);
  };

  getSubAgentRoleData = async (agentId, agentEmail) => {
    const listSubAgentAssignRoles = await listMySubAgentRoles(
      auth.getAccount(),
      auth.getToken(),
      agentId,
      agentEmail
    );

    // console.log("ListSubAgentRoles Res: ", listSubAgentAssignRoles.data.data);
    if (
      listSubAgentAssignRoles.data.status === 403 ||
      listSubAgentAssignRoles.data.errors === "authentication missing" ||
      listSubAgentAssignRoles.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (listSubAgentAssignRoles.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      listSubAgentAssignRoles.data.status === 200 &&
      listSubAgentAssignRoles.data.message === "success"
    ) {
      const assignRoleData = listSubAgentAssignRoles.data.data.roles;
      const assignSubRoleData = listSubAgentAssignRoles.data.data.subroles;
      const allRoleData = listSubAgentAssignRoles.data.data.Allroles.map(
        (role) => {
          const isActiveRole = assignRoleData.some(
            (assignedRole) =>
              assignedRole.alt === role.alt && assignedRole.isactive === 1
          );
          return {
            ...role,
            isChecked: isActiveRole,
          };
        }
      );

      const allSubRoleData = listSubAgentAssignRoles.data.data.Allsubroles.map(
        (subRole) => {
          const isActiveSubRole = assignSubRoleData.some(
            (assignedSubRole) =>
              assignedSubRole.alt === subRole.alt &&
              assignedSubRole.isactive === 1
          );
          return {
            ...subRole,
            isChecked: isActiveSubRole,
          };
        }
      );

      this.setState({
        assignRoleData,
        assignSubRoleData,
        allRoleData,
        allSubRoleData,
        agentRoleLoader: false,
      });

      const initialActiveRoles = assignRoleData
        .filter((role) => role.isactive === 1)
        .map((role) => ({
          alt: role.alt,
          isChecked: true,
        }));

      const initialActiveSubRoles = assignSubRoleData
        .filter((subRole) => subRole.isactive === 1)
        .map((subRole) => ({
          id: subRole.id,
          isChecked: true,
        }));

      this.setState({
        changedRolesRights: initialActiveRoles,
        changedSubRolesRights: initialActiveSubRoles,
      });
    } else {
      //window.location.replace("/error");
    }
  };

  changedAllRolesRights = (event) => {
    const { name, checked } = event.target;

    // Update checkedRoleIds in the state
    const { checkedRoleIds } = this.state;
    const updatedCheckedRoleIds = checked
      ? [...checkedRoleIds, name] // add ID if checked
      : checkedRoleIds.filter((id) => id !== name); // remove ID if unchecked

    this.setState({ checkedRoleIds: updatedCheckedRoleIds });

    // Update allRoleData with isChecked property
    const { allRoleData, allSubRoleData } = this.state;
    const updatedAllRoleData = allRoleData.map((role) => {
      if (role.id.toString() === name) {
        return {
          ...role,
          isChecked: checked,
        };
      }
      return role;
    });

    // Update associated sub roles
    const updatedAllSubRoleData = allSubRoleData.map((subRole) => {
      if (subRole.role_id.toString() === name) {
        return {
          ...subRole,
          isChecked: checked,
        };
      }
      return subRole;
    });

    this.setState({
      allRoleData: updatedAllRoleData,
      allSubRoleData: updatedAllSubRoleData,
    });
  };

  changedAllSubRolesRights = (event) => {
    const { name, checked } = event.target;

    // Update checkedSubRoleIds in the state
    const { checkedSubRoleIds } = this.state;
    const updatedCheckedSubRoleIds = checked
      ? [...checkedSubRoleIds, name] // add ID if checked
      : checkedSubRoleIds.filter((id) => id !== name); // remove ID if unchecked

    this.setState({ checkedSubRoleIds: updatedCheckedSubRoleIds });

    // Update allSubRoleData with isChecked property
    const { allSubRoleData } = this.state;
    const updatedAllSubRoleData = allSubRoleData.map((subRole) => {
      if (subRole.tabdetailid.toString() === name) {
        return {
          ...subRole,
          isChecked: checked,
        };
      }
      return subRole;
    });

    this.setState({ allSubRoleData: updatedAllSubRoleData });
  };

  handleSubmitRoleCheckbox = async (name, email) => {
    this.setState({
      errorMessageAgentRole: "",
      successMessageAgentRole: "",
      disableRoleBtn: true,
    });

    const { allRoleData, allSubRoleData } = this.state;

    // Prepare the CheckRoleFields array with IDs and isactive status
    const CheckRoleFields = allRoleData.map((role) => ({
      id: role.id,
      isactive: role.isChecked ? 1 : 0,
    }));

    const CheckSubRoleFields = allSubRoleData.map((role) => ({
      id: role.tabdetailid,
      isactive: role.isChecked ? 1 : 0,
    }));

    try {
      // Call the backend API to save the roles
      const saveResponce = await editMySubAgentRoles(
        auth.getAccount(),
        auth.getToken(),
        CheckRoleFields,
        CheckSubRoleFields,
        name,
        email
      );

      // Handle response status
      if (
        saveResponce.data.status === 403 ||
        saveResponce.data.errors === "authentication missing" ||
        saveResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (saveResponce.data.status === 404) {
        this.setState({
          errorMessageAgentRole:
            "There is some error while updating the menu permissions.",
          successMessageAgentRole: "",
          disableRoleBtn: false,
        });
      } else if (
        saveResponce.data.status === 200 &&
        saveResponce.data.message === "success"
      ) {
        this.setState({
          errorMessageAgentRole: "",
          successMessageAgentRole: "Menu permissions updated successfully.",
          disableRoleBtn: false,
        });
        setTimeout(() => {
          window.$("#modalSubAgentAssignRole").modal("hide");
        }, 3000);
      } else {
        this.setState({
          errorMessageAgentRole: saveResponce.data.message,
          successMessageAgentRole: "",
          disableRoleBtn: false,
        });
      }
    } catch (error) {
      console.error("Error while saving roles:", error);
      this.setState({
        errorMessageAgentRole: "An error occurred while saving roles.",
        successMessageAgentRole: "",
        disableRoleBtn: false,
      });
    }
  };

  setStatus = (value, tableMeta) => {
    let domain_str = tableMeta.rowData[4];
    // console.log("domain_str: ", domain_str);
    if (domain_str === "active") {
      return (
        <div>
          <span className="badge badge-outline-success">
            {" "}
            <em className="icon ni ni-done" title="Active"></em> Active
          </span>
        </div>
      );
    } else {
      return (
        <div>
          <span className="badge badge-outline-danger">
            {" "}
            <em className="icon ni ni-alert-c"></em> Inactive
          </span>
        </div>
      );
    }
  };

  setMarkUp = async (value, tableMeta) => {
    this.setState({
      product_desc: tableMeta.rowData[8],
    });
    window.$("#modalFormDetail").modal("show");
  };

  agentSplit = async (value, tableMeta) => {
    let sub_agent_id = value;
    const servicesResponce = await listServices(
      auth.getAccount(),
      auth.getToken()
    );
    // console.log("servicesResponce.data.data: ", servicesResponce.data);
    this.setState({
      errorMessage: "",
      successMessage: "",
    });
    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      let formValues = [];
      let all_data = servicesResponce.data.data;
      for (let i = 0; i < all_data.length; i++) {
        let created = "80/20_" + all_data[i][0];
        formValues.push(created);
      }
      this.setState({
        servicesData: servicesResponce.data.data,
        tableLoader: false,
        tableLoaderListing: false,
        sub_agent_id: sub_agent_id,
        formValues: formValues,
      });
      this.getAgentSplit(servicesResponce.data.data);
    } else {
      //window.location.replace("/error");
    }
    window.$("#modalFormSplit").modal("show");
  };

  getAgentSplit = async (services) => {
    let { sub_agent_id } = this.state;

    const servicesResponce = await getAgentSplit(
      auth.getAccount(),
      auth.getToken(),
      sub_agent_id,
      JSON.stringify(services)
    );
    // console.log("getAgentSplit: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        tableLoader: false,
        tableLoaderListing: false,
      });
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        splitData: servicesResponce.data.data,
        tableLoader: false,
        tableLoaderListing: false,
      });
    } else {
      this.setState({
        tableLoader: false,
        tableLoaderListing: false,
      });
    }
  };

  editAgentForm = async (value, tableMeta) => {
    let agent_id = tableMeta.rowData[5];
    const servicesResponce = await getMySingleSubAgent(
      auth.getAccount(),
      auth.getToken(),
      agent_id
    );
    // console.log("servicesResponce.data.data: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        title: servicesResponce.data.data[0]["title"],
        // Role is a separate field from Title; prefill for the edit form.
        role: servicesResponce.data.data[0]["role"] || "",
        name: servicesResponce.data.data[0]["name"],
        agent_email: servicesResponce.data.data[0]["email"],
        agent_phone: servicesResponce.data.data[0]["phone"],
        agent_id: servicesResponce.data.data[0]["id"],
        comp: servicesResponce.data.data[0]["comp_name"],
        address: servicesResponce.data.data[0]["address"],
        address2: servicesResponce.data.data[0]["address2"],
        city: servicesResponce.data.data[0]["city"],
        state: servicesResponce.data.data[0]["state"],
        zip: servicesResponce.data.data[0]["zip"],
        country: servicesResponce.data.data[0]["country"],
        account_status: servicesResponce.data.data[0]["account_status"],
        tableLoader: false,
      });
      window.$("#modalFormDetail").modal("show");
    } else {
      // window.location.replace("/error");
    }
  };

  formUpdateSubmit = async () => {
    let {
      title,
      name,
      agent_email,
      agent_password,
      c_password,
      agent_phone,
      comp,
      city,
      state,
      zip,
      address,
      address2,
      country,
      account_status,
    } = this.state;

    this.setState({
      errorMessageEdit: "",
      errorName: "",
      errorStatus: "",
      errorAgentCompany: "",
      errorAgentEmail: "",
      errorAgentPhone: "",
      errorAgentAddress: "",
      errorAgentCity: "",
      errorAgentState: "",
      errorAgentZip: "",
      errorAgentCountry: "",
      errorAgentPassword: "",
      errorCPassword: "",
    });
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
    const modalBody = document.getElementById("modalFormDetail");
    if (modalBody) {
      setTimeout(() => {
        modalBody.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }, 0);
    }

    let is_validated = true;
    if (this.state.name === "") {
      this.setState({
        errorName: "error",
        errorMessageEdit: "Full Name is required.",
      });
      is_validated = false;
    } else if (this.state.comp === "") {
      this.setState({
        errorName: "",
        errorAgentCompany: "error",
        errorMessageEdit: "Company is required.",
      });
      is_validated = false;
    } else if (this.state.agent_phone === "") {
      this.setState({
        errorAgentCompany: "",
        errorAgentPhone: "error",
        errorMessageEdit: "Phone is required.",
      });
      is_validated = false;
    } else if (!this.isPhoneValid(this.state.agent_phone)) {
      this.setState({
        errorAgentCompany: "",
        errorAgentPhone: "error",
        errorMessageEdit: "Invalid phone format.",
      });
      is_validated = false;
    } else if (this.state.address === "") {
      this.setState({
        errorAgentPhone: "",
        errorAgentAddress: "error",
        errorMessageEdit: "Address is required.",
      });
      is_validated = false;
    } else if (this.state.city === "") {
      this.setState({
        errorAgentAddress: "",
        errorAgentCity: "error",
        errorMessageEdit: "City is required.",
      });
      is_validated = false;
    } else if (this.state.state === "") {
      this.setState({
        errorAgentCity: "",
        errorAgentState: "error",
        errorMessageEdit: "State is required.",
      });
      is_validated = false;
    } else if (this.state.zip === "") {
      this.setState({
        errorAgentState: "",
        errorAgentZip: "error",
        errorMessageEdit: "Zip is required.",
      });
      is_validated = false;
    } else if (this.state.country === "") {
      this.setState({
        errorAgentZip: "",
        errorAgentCountry: "error",
        errorMessageEdit: "Country is required.",
      });
      is_validated = false;
    } else if (this.state.agent_password !== "") {
      if (this.state.agent_password.length < 8) {
        this.setState({
          errorAgentCountry: "",
          errorAgentPassword: "error",
          errorMessageEdit: "Use 8 characters or more for your password",
        });
        is_validated = false;
      } else if (!passwordRegex.test(agent_password)) {
        this.setState({
          errorAgentCountry: "",
          errorAgentPassword: "error",
          errorMessageEdit:
            "Password must be at least 8 characters, with uppercase, lowercase, number & special character.",
        });
        is_validated = false;
      } else if (this.state.c_password === "") {
        this.setState({
          errorAgentPassword: "",
          errorCPassword: "error",
          errorMessageEdit: "Confirm password is required.",
        });
        is_validated = false;
      } else if (this.state.c_password.length < 8) {
        this.setState({
          errorAgentPassword: "",
          errorCPassword: "error",
          errorMessageEdit:
            "Use 8 characters or more for your confirm password",
        });
        is_validated = false;
      } else if (
        this.state.agent_password.trim() != this.state.c_password.trim()
      ) {
        this.setState({
          errorAgentPassword: "",
          errorCPassword: "error",
          errorMessageEdit: "Password and confirm password does not match.",
        });
        is_validated = false;
      }
    }
    if (is_validated) {
      let apiResponce = await editMySubAgent(
        auth.getAccount(),
        auth.getToken(),
        title,
        name,
        agent_email,
        agent_password,
        agent_phone,
        this.state.agent_id,
        address,
        address2,
        zip,
        country,
        city,
        state,
        comp,
        account_status,
        this.state.notifyCheckBox.toString(),
        this.state.role
      );

      if (
        apiResponce.data.status === 403 ||
        apiResponce.data.errors === "authentication missing" ||
        apiResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (
        apiResponce.data.status === 409 &&
        apiResponce.data.message === "Address validation failed"
      ) {
        this.setState({
          errorMessageEdit: apiResponce.data.errors
            ? String(apiResponce.data.errors).replace(/,/g, "<br />")
            : "Address validation failed",
          disabled: false,
        });
      } else if (
        apiResponce.data.status === 200 &&
        apiResponce.data.message === "Success"
      ) {
        this.setState({
          successMessageEdit: "Sub Agent partner updated successfully.",
          errorMessageEdit: "",
          tableLoader: false,
        });
        setTimeout(async function () {
          //window.$("#modalFormDetail").modal("hide");
          window.location.replace("/sub_agents");
        }, 3000);
      } else if (
        apiResponce.data.status === 404 &&
        apiResponce.data.message === "fail"
      ) {
        this.setState({
          errorMessageEdit: "Something went wrong,try again later.",
          successMessageEdit: "",
          disabled: false,
          tableLoader: false,
        });
        return false;
      } else {
        this.setState({
          errorMessageEdit: "Something went wrong,try again later.",
          successMessageEdit: "",
          disabled: false,
          tableLoader: false,
        });
        //auth.logout();
      }
    }
  };

  handleChange = (event) => {
    const { target } = event;
    let value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;
    if (name === "name") {
      value = value.replace(/[^a-zA-Z\s'.,\-:()|!@]/g, "");
    } else if (name === "title") {
      value = value.replace(/[^a-zA-Z0-9\s_\-.,&:()|!@]/g, "");
    } else if (name === "comp") {
      value = value.replace(/[^a-zA-Z0-9\s_\-.,&:()|!@]/g, "");
    }
    this.setState({
      [name]: value,
    });
  };

  handleChangeSplit = (e, i) => {
    // console.log(
    //   "e.target.name  :  e.target.value",
    //   e.target.name + " : " + e.target.value
    // );
    let formValues = [...this.state.formValues];
    formValues[i] = e.target.value;
    this.setState({ formValues });
  };

  addMenuHistory = (link) => {
    this.props.props.history.push(link);
  };

  formSplitUpdate = async () => {
    let { formValues, sub_agent_id } = this.state;

    const servicesResponce = await addAgentSplit(
      auth.getAccount(),
      auth.getToken(),
      sub_agent_id,
      JSON.stringify(this.state.formValues)
    );
    // console.log("sub_agent_id: ", sub_agent_id);
    // console.log("formValues: ", this.state.formValues);
    // console.log("formSplitUpdate: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        errorMessage: "There is some error while adding the sub agent split.",
        successMessage: "",
      });
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        errorMessage: "",
        successMessage: "Sub Agent split added successfully",
      });
      this.getAgentSplit(this.state.servicesData);
    } else {
      this.setState({
        errorMessage: "There is some error while adding the sub agent split.",
        successMessage: "",
      });
      //window.location.replace("/error");
    }
    setTimeout(() => {
      this.setState({ successMessage: "", errorMessage: "" });
    }, 4000);
  };

  handleChangeCountry = (event) => {
    const country = event?.label || "";
    this.setState({
      country: country,
    });
  };

  setNewAgentSettings = async () => {
    this.setState({
      errorMessageInvite: "",
      successMessageInvite: "",
      agent_name: "",
      agent_email: "",
      invitation_comment: "",
    });
    window.$("#modalAddNewAgent").modal("show");
  };

  saveNewAgent = async () => {
    const { agent_name, agent_email, invitation_comment } = this.state;
    this.setState({
      errorMessageInvite: "",
      successMessageInvite: "",
      disabled: true,
    });

    if (agent_name === "") {
      this.setState({
        errorMessageInvite: "Please enter the name.",
        successMessageInvite: "",
        disabled: false,
      });
    } else if (agent_email === "") {
      this.setState({
        errorMessageInvite: "Please enter the email address.",
        successMessageInvite: "",
        disabled: false,
      });
    } else if (ValidateEmail(agent_email) === false) {
      this.setState({
        errorMessageInvite: "Please enter the valid email address.",
        successMessageInvite: "",
        disabled: false,
      });
    } else if (invitation_comment === "") {
      this.setState({
        errorMessageInvite: "Please enter the comment.",
        successMessageInvite: "",
        disabled: false,
      });
    } else {
      const servicesResponce = await sendMySubAgentInvite(
        auth.getAccount(),
        auth.getToken(),
        agent_email,
        agent_name,
        invitation_comment
      );

      // console.log("agentsResponce.data.data: ", servicesResponce.data);

      if (
        servicesResponce.data.status === 403 ||
        servicesResponce.data.errors === "authentication missing" ||
        servicesResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (servicesResponce.data.status === 409) {
        this.setState({
          errorMessageInvite:
            "An account with this email already exists. Invitation not sent.",
          successMessageInvite: "",
          disabled: false,
        });
      } else if (servicesResponce.data.status === 404) {
        this.setState({
          errorMessageInvite:
            "There is some error while sending invite to the sub agent.",
          successMessageInvite: "",
          disabled: false,
        });
      } else if (
        servicesResponce.data.status === 200 &&
        servicesResponce.data.message === "success"
      ) {
        this.setState({
          errorMessageInvite: "",
          successMessageInvite: "Invite successfully sent to the sub agent.",
          disabled: false,
          client_email: "",
          client_name: "",
          tableData_invitedClients: servicesResponce.data.invited_clients,
        });
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      } else {
        this.setState({
          errorMessageInvite:
            "There is some error while sending invite to the sub agent.",
          successMessageInvite: "",
          disabled: false,
        });
      }
    }
    setTimeout(() => {
      this.setState({
        errorMessageInvite: "",
        successMessageInvite: "",
      });
    }, 4000);
  };

  getInviteData = async () => {
    const servicesResponce = await getMySubAgentInvites(
      auth.getAccount(),
      auth.getToken()
    );
    // console.log("Available Sub Agents: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.clientLogout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        tableLoader: false,
        tableLoaderListing: false,
      });
    } else if (servicesResponce.data.status === 200) {
      this.setState({
        tableData_invitedAgents: servicesResponce.data.data,
        tableLoader: false,
        tableLoaderListing: false,
      });
    } else {
      this.setState({
        tableLoader: false,
        tableLoaderListing: false,
      });
    }
  };

  handleTabClick = (tabId) => {
    this.setState({ activeTabCP: tabId });
  };

  format_date = (value, tableMeta) => {
    let date = value;
    return dateFormat(date, "mm-dd-yyyy");
  };

  assignedTo = (value, tableMeta) => {
    let invitation_comment = tableMeta.rowData[3];
    this.setState(
      {
        invitation_comment: invitation_comment,
      },
      () => {
        window.$("#modalInvitationComment").modal("show");
      }
    );
  };

  deleteAlert = async (value) => {
    let id = value;
    this.setState({
      delete_id: id,
    });
    window.$("#modalDeleteAlert").modal("show");
  };

  modalHideDel = () => {
    window.$("#modalDeleteAlert").modal("hide");
  };

  deleteInviteAgent = async () => {
    let agent_id = this.state.delete_id;

    this.setState({
      errorMessageInvite: "",
      successMessageInvite: "",
      disabled: true,
    });

    const userResponce = await deleteMySubAgentInvite(
      auth.getAccount(),
      auth.getToken(),
      agent_id
    );

    // console.log("deleteClientInvite: ", userResponce.data);

    if (
      userResponce.data.status === 403 ||
      userResponce.data.errors === "authentication missing" ||
      userResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      userResponce.data.status === 404 &&
      userResponce.data.message === "fail" &&
      userResponce.data.note !== ""
    ) {
      this.setState({
        errorMessageInvite: "Error deleting the invited sub agent.",
        successMessageInvite: "",
        disabled: false,
      });
    } else if (
      userResponce.data.status === 200 &&
      userResponce.data.message === "success"
    ) {
      this.setState({
        errorMessageInvite: "",
        successMessageInvite: "Invited Sub Agent deleted successfully.",
        disabled: false,
      });

      setTimeout(function () {
        window.location.reload();
        window.$("#modalDeleteAlert").modal("hide");
      }, 3000);
    } else {
      this.setState({
        errorMessageInvite: "Error deleting the invited sub agent.",
        successMessageInvite: "",
        disabled: false,
      });
    }
  };

  copyToClipboard = (text, rowId) => {
    navigator.clipboard.writeText(text);
    this.setState({ copiedRowId: rowId });
    setTimeout(() => {
      this.setState({ copiedRowId: null });
    }, 3000);
  };

  resendInvite = async (agent_email, agent_name, invitation_comment) => {
    this.setState({
      errorMessageInvite: "",
      successMessageInvite: "",
      disabled: true,
    });

    const servicesResponce = await sendMySubAgentInvite(
      auth.getAccount(),
      auth.getToken(),
      agent_email,
      agent_name,
      invitation_comment
    );

    window.$("#modalresendInvitation").modal("show");

    // console.log("agentsResponce.data.data: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 409) {
      this.setState({
        errorMessageInvite:
          "An account with this email already exists. Invitation not sent.",
        successMessageInvite: "",
        disabled: false,
      });
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        errorMessageInvite: "Error sending invitation email.",
        successMessageInvite: "",
        disabled: false,
      });
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState(
        {
          errorMessageInvite: "",
          successMessageInvite: "Invitation email sent successfully.",
          disabled: false,
        },
        () => {
          setTimeout(() => {
            window.location.reload();
          }, 3000);
        }
      );
    } else {
      this.setState({
        errorMessageInvite: "Error Sending Activation Email",
        successMessageInvite: "",
        disabled: false,
      });
    }
  };

  modalHideResend = () => {
    window.$("#modalresendInvitation").modal("hide");
  };

  // Login-as-Sub-Agent (SSO): fetches the SSO login URL for the Sub-Agent's
  // portal account and opens it in a new tab. NOTE: the portal session
  // cookies are shared browser-wide, so the new tab's Sub-Agent session
  // replaces the current Main Agent session.
  subAgentLogin = async (tableMeta) => {
    const agentId = tableMeta.rowData[5];
    this.setState({
      errorMessageInvite: "",
      successMessageInvite: "Connecting to the Sub Agent account...",
    });
    window.$("#modalresendInvitation").modal("show");
    const loginResponce = await getMySubAgentLogin(
      auth.getAccount(),
      auth.getToken(),
      agentId
    );
    if (
      loginResponce.data.status === 403 ||
      loginResponce.data.errors === "authentication missing" ||
      loginResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      loginResponce.data.status === 404 &&
      loginResponce.data.message === "inactive"
    ) {
      this.setState({
        errorMessageInvite: "Sub Agent account is not active.",
        successMessageInvite: "",
      });
    } else if (
      loginResponce.data.status === 404 &&
      loginResponce.data.message === "notVerified"
    ) {
      this.setState({
        errorMessageInvite:
          "Sub Agent account is not verified yet. The Sub Agent must verify their email first.",
        successMessageInvite: "",
      });
    } else if (
      loginResponce.data.status === 200 &&
      loginResponce.data.message === "success" &&
      loginResponce.data.login_url
    ) {
      this.setState({
        errorMessageInvite: "",
        successMessageInvite: "",
      });
      window.$("#modalresendInvitation").modal("hide");
      window.open(loginResponce.data.login_url, "_blank");
    } else {
      this.setState({
        errorMessageInvite:
          "There is some error while authenticating the Sub Agent account.",
        successMessageInvite: "",
      });
    }
  };

  openAssignProducts = async (tableMeta) => {
    const agentId = tableMeta.rowData[5];
    this.setState({
      products_agent_id: agentId,
      productsAgentName: tableMeta.rowData[2],
      productsLoader: true,
      productsData: [],
      errorMessageProducts: "",
      successMessageProducts: "",
      disableProductsBtn: false,
    });
    window.$("#modalAssignProducts").modal("show");
    const servicesResponce = await getMySubAgentServices(
      auth.getAccount(),
      auth.getToken(),
      agentId
    );
    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      const assigned = servicesResponce.data.assigned_services || [];
      const productsData = (servicesResponce.data.data || []).map(
        (service) => ({
          ...service,
          isChecked: assigned.includes(Number(service.id)),
        })
      );
      this.setState({ productsData: productsData, productsLoader: false });
    } else {
      this.setState({ productsData: [], productsLoader: false });
    }
  };

  handleProductCheckbox = (event) => {
    const { name, checked } = event.target;
    this.setState((prevState) => ({
      productsData: prevState.productsData.map((service) =>
        String(service.id) === name
          ? { ...service, isChecked: checked }
          : service
      ),
    }));
  };

  saveAssignProducts = async () => {
    this.setState({
      errorMessageProducts: "",
      successMessageProducts: "",
      disableProductsBtn: true,
    });
    const assigned_services = this.state.productsData.map((service) => ({
      id: service.id,
      checked: service.isChecked === true,
    }));
    const saveResponce = await updateMySubAgentServices(
      auth.getAccount(),
      auth.getToken(),
      this.state.products_agent_id,
      JSON.stringify(assigned_services)
    );
    if (
      saveResponce.data.status === 403 ||
      saveResponce.data.errors === "authentication missing" ||
      saveResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      saveResponce.data.status === 200 &&
      saveResponce.data.message === "success"
    ) {
      this.setState({
        successMessageProducts: "Products updated successfully.",
        disableProductsBtn: false,
      });
      setTimeout(() => {
        window.$("#modalAssignProducts").modal("hide");
      }, 3000);
    } else {
      this.setState({
        errorMessageProducts:
          "There is some error while updating the products.",
        disableProductsBtn: false,
      });
    }
  };

  openCommissionAllocation = async (tableMeta) => {
    const agentId = tableMeta.rowData[5];
    this.setState({
      commission_agent_id: agentId,
      commissionAgentName: tableMeta.rowData[2],
      commissionLoader: true,
      commission_percentage: "",
      commission_main_rate: null,
      errorMessageCommission: "",
      successMessageCommission: "",
      disableCommissionBtn: false,
    });
    window.$("#modalCommissionAllocation").modal("show");
    const allocationResponce = await getMySubAgentCommissionAllocation(
      auth.getAccount(),
      auth.getToken(),
      agentId
    );
    if (
      allocationResponce.data.status === 403 ||
      allocationResponce.data.errors === "authentication missing" ||
      allocationResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      allocationResponce.data.status === 200 &&
      allocationResponce.data.message === "success"
    ) {
      const allocation = allocationResponce.data.data || {};
      this.setState({
        commission_percentage:
          allocation.sub_percentage !== undefined &&
          allocation.sub_percentage !== null
            ? String(allocation.sub_percentage)
            : "",
        commission_main_rate: allocation.main_rate,
        commissionLoader: false,
      });
    } else {
      this.setState({ commissionLoader: false });
    }
  };

  saveCommissionAllocation = async () => {
    const pct = this.state.commission_percentage;
    this.setState({
      errorMessageCommission: "",
      successMessageCommission: "",
    });
    if (
      pct === "" ||
      isNaN(parseFloat(pct)) ||
      parseFloat(pct) < 0 ||
      parseFloat(pct) > 100
    ) {
      this.setState({
        errorMessageCommission:
          "Enter a valid percentage between 0 and 100 (decimals allowed).",
      });
      return;
    }
    this.setState({ disableCommissionBtn: true });
    const saveResponce = await saveMySubAgentCommissionAllocation(
      auth.getAccount(),
      auth.getToken(),
      this.state.commission_agent_id,
      pct
    );
    if (
      saveResponce.data.status === 403 ||
      saveResponce.data.errors === "authentication missing" ||
      saveResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      saveResponce.data.status === 409 &&
      saveResponce.data.message === "over_allocation"
    ) {
      const max =
        saveResponce.data.data && saveResponce.data.data.max !== undefined
          ? saveResponce.data.data.max
          : "";
      this.setState({
        errorMessageCommission:
          "A Sub Agent's commission cannot exceed your own commission rate (max " +
          max +
          "%).",
        disableCommissionBtn: false,
      });
    } else if (
      saveResponce.data.status === 200 &&
      saveResponce.data.message === "success"
    ) {
      // Close as soon as the API returns 200, then refresh the listing in
      // place. It used to wait 2.5s and then reload the whole page, so the
      // close was never seen and the popup appeared stuck.
      this.setState({
        successMessageCommission: "Commission allocation saved successfully.",
        disableCommissionBtn: false,
      });
      window.$("#modalCommissionAllocation").modal("hide");
      this.loadSubAgents();
    } else {
      this.setState({
        errorMessageCommission:
          "There is some error while saving the commission allocation.",
        disableCommissionBtn: false,
      });
    }
  };


  render() {
    const { useGooglePlaces, toggleButtonText } = this.state;
    const errorStyle = {
      control: (provided) => ({
        ...provided,
        borderColor: this.state.errorAgentAddress ? "red" : "#d3d3d3",
        height: "57px",
      }),
    };
    return (
      <>
        <div className="nk-content ">
          <div className="container-fluid">
            {/* MSA WARNING  START*/}
            {this.props.defaultSettings === "missing" ? <SettingsError /> : null}
            {this.props.is_msa_signed === "No" ? <MsaWarning /> : null}
            {/* MSA WARNING END */}
            <div className="nk-content-inner">
              <div className="nk-content-body">
                {/* PAGE TITLE START */}
                <div className="nk-block-head nk-block-head-sm">
                  <div className="nk-block-between">
                    <div className="nk-block-head-content">
                      <h3 className="nk-block-title page-title">
                        <PageTitle name="Sub Agents" icon="icon ni ni-user-list" />
                      </h3>
                    </div>
                    <div className="nk-block-head-content" id="HeadContent">
                      <div className="toggle-wrap nk-block-tools-toggle">
                        <a
                          href="#"
                          className="btn btn-icon btn-trigger toggle-expand mr-n1"
                          data-target="pageMenu"
                        >
                          <em className="icon ni ni-more-v"></em>
                        </a>
                        <div
                          className="toggle-expand-content"
                          data-content="pageMenu"
                        >
                          <ul className="nk-block-tools g-3">
                            <li className="nk-block-tools-opt">
                              <a
                                onClick={() => this.setNewAgentSettings()}
                                className="btn btn-primary"
                                style={{ color: "white" }}
                              >
                                <em className="icon ni ni-plus-round"></em>
                                &nbsp;Invite New Sub Agent
                              </a>
                            </li>
                            <li className="nk-block-tools-opt">
                              <Link
                                color="inherit"
                                onClick={() =>
                                  this.addMenuHistory("/sub_agents/addsubagent")
                                }
                                className="btn btn-primary"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  cursor: "pointer",
                                  color: "#fff",
                                }}
                              >
                                <em className="icon ni ni-plus-round"></em>
                                &nbsp;Add New Sub Agent
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* PAGE TITLE END */}
                <div className="nk-block">
                  {/* Table 5th Col Start */}
                  <div className="row g-gs">
                    <div className="col-xxl-12">
                      <div className="row g-gs" style={{ clear: "both" }}>
                        <div className="col-lg-12">
                          <div
                            className="card card-bordered"
                            style={{ clear: "both" }}
                          >
                            <div className="card-inner">
                              <ul className="nav nav-tabs">
                                <li className="nav-item">
                                  <a
                                    className={`nav-link ${
                                      this.state.activeTabCP === "tabItem7"
                                        ? "active"
                                        : ""
                                    }`}
                                    data-toggle="tab"
                                    href="#tabItem7"
                                    onClick={() =>
                                      this.handleTabClick("tabItem7")
                                    }
                                  >
                                    <em className="icon ni ni-user-list"></em>
                                    <span>All Sub Agents</span>
                                  </a>
                                </li>
                                <li className="nav-item">
                                  <a
                                    className={`nav-link ${
                                      this.state.activeTabCP === "tabItem8"
                                        ? "active"
                                        : ""
                                    }`}
                                    data-toggle="tab"
                                    href="#tabItem8"
                                    onClick={() => {
                                      this.handleTabClick("tabItem8");
                                      this.getInviteData();
                                    }}
                                  >
                                    <em className="icon ni ni-user-add"></em>
                                    <span>Pending Invitations</span>
                                  </a>
                                </li>
                              </ul>
                              <div className="tab-content" style={{ marginTop: 0 }}>
                                <div
                                  className={`tab-pane ${
                                    this.state.activeTabCP === "tabItem7"
                                      ? "active"
                                      : ""
                                  }`}
                                  id="tabItem7"
                                >
                                  <div className="row">
                                    <div className="col-md-12">
                                      {this.state.tableLoader === true ? (
                                        tableLoader()
                                      ) : (
                                        <DataTable
                                          columns={this.state.columnServices}
                                          tableData={this.state.tableData}
                                          title="All Sub Agents"
                                          options={{
                                            // Commission % (7) and Main
                                            // Keeps % (8) shown right after
                                            // Status, before Action; hidden
                                            // ACCOUNT # (6) unmoved.
                                            columnOrder: [
                                              0, 1, 2, 3, 4, 7, 8, 5, 6,
                                            ],
                                          }}
                                        />
                                      )}
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className={`tab-pane ${
                                    this.state.activeTabCP === "tabItem8"
                                      ? "active"
                                      : ""
                                  }`}
                                  id="tabItem8"
                                >
                                  <div className="row">
                                    <div className="col-md-12">
                                      {this.state.tableLoader === true ? (
                                        tableLoader()
                                      ) : (
                                        <DataTable
                                          columns={
                                            this.state
                                              .columnServices_invitedAgents
                                          }
                                          tableData={
                                            this.state.tableData_invitedAgents
                                          }
                                          title="Pending Invitations"
                                        />
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Table 5th Col End */}
                </div>
                {/* EDIT MODAL End */}
                <div className="modal fade" tabIndex="-1" id="modalFormDetail">
                  <div className="modal-dialog modal-xl" role="document">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">
                          {" "}
                          <em className="icon ni ni-edit"></em> Edit Sub Agent
                        </h5>
                        <a
                          href="#"
                          className="close"
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          <em className="icon ni ni-cross"></em>
                        </a>
                      </div>

                      <div className="modal-body">
                        {/* Error Start */}
                        {this.state.errorMessageEdit !== "" ? (
                          <div
                            className="example-alert"
                            style={{ marginBottom: "20px" }}
                          >
                            <div className="alert alert-pro alert-danger">
                              <div className="alert-text">
                                <h4>Error</h4>
                                <p
                                  dangerouslySetInnerHTML={{
                                    __html: this.state.errorMessageEdit,
                                  }}
                                ></p>
                              </div>
                            </div>
                          </div>
                        ) : null}
                        {this.state.successMessageEdit !== "" ? (
                          <div
                            className="example-alert"
                            style={{ marginBottom: "20px" }}
                          >
                            <div className="alert alert-pro alert-success">
                              <div className="alert-text">
                                <h4>Success</h4>
                                <p>{this.state.successMessageEdit}</p>
                              </div>
                            </div>
                          </div>
                        ) : null}
                        <br />
                        <div className="row g-4">
                          <form method="post" autoComplete="off" encType="multipart/form-data">
                            <div className="row g-4">
                              <div className="form-group col-md-6">
                                <MutextField
                                  required
                                  id="name"
                                  name="name"
                                  type="text"
                                  label="Full Name"
                                  inputProps={{ maxLength: 100 }}
                                  value={this.state.name}
                                  onChange={this.handleChange}
                                  helperText="Enter the name. Allowed characters: (&nbsp; ' &nbsp; - &nbsp; . &nbsp; , &nbsp; : &nbsp; ( ) &nbsp; | &nbsp; ! &nbsp; @ )"
                                  variant="outlined"
                                  fullWidth
                                  error={this.state.errorName === "error"}
                                />
                              </div>

                              <div className="form-group col-md-3">
                                <MutextField
                                  id="title"
                                  name="title"
                                  type="text"
                                  inputProps={{ maxLength: 30 }}
                                  label="Title"
                                  value={this.state.title}
                                  onChange={this.handleChange}
                                  helperText="Enter the title. Allowed characters: (&nbsp; _ &nbsp; - &nbsp; . &nbsp; &amp; &nbsp; , &nbsp; : &nbsp; ( ) &nbsp; | &nbsp; ! &nbsp; @ )"
                                  variant="outlined"
                                  fullWidth
                                />
                              </div>

                              {this.state.role_field_enabled ? (
                                <div className="form-group col-md-3">
                                  <MutextField
                                    id="role"
                                    name="role"
                                    type="text"
                                    inputProps={{ maxLength: 30 }}
                                    label="Role"
                                    value={this.state.role}
                                    onChange={this.handleChange}
                                    variant="outlined"
                                    fullWidth
                                  />
                                </div>
                              ) : null}

                              <div className="form-group col-md-3">
                                <MutextField
                                  required
                                  id="comp"
                                  name="comp"
                                  type="text"
                                  inputProps={{ maxLength: 30 }}
                                  label="Company Name"
                                  value={this.state.comp}
                                  onChange={this.handleChange}
                                  helperText="Enter the company name. Allowed characters: (&nbsp; _ &nbsp; . &nbsp; - &nbsp; , &nbsp; : &nbsp; &amp; &nbsp; ( ) &nbsp; | &nbsp; ! &nbsp; @ )"
                                  variant="outlined"
                                  fullWidth
                                  error={this.state.errorAgentCompany === "error"}
                                />
                              </div>

                              <div className="form-group col-md-6">
                                <MutextField
                                  required
                                  id="agent_email"
                                  name="agent_email"
                                  type="email"
                                  label="Email Address"
                                  value={this.state.agent_email}
                                  onChange={this.handleChange}
                                  helperText="Enter your email address here."
                                  variant="outlined"
                                  fullWidth
                                  disabled
                                  InputProps={{
                                    readOnly: true,
                                  }}
                                />
                              </div>

                              <div className="form-group col-md-6">
                                {/*<PhoneInput
                                  style={{ height: "71%" }}
                                  required
                                  defaultCountry={"us"}
                                  error={this.state.errorPhone}
                                  inputProps={{
                                    name: "agent_phone",
                                    id: "agent_phone",
                                    maxLength: 20,
                                  }}
                                  value={this.state.agent_phone}
                                  onChange={(value) =>
                                    this.handleChange({
                                      target: { name: "agent_phone", value },
                                    })
                                  }
                                  helperText="Enter the agent phone number."
                                  label="Agent Phone Number"
                                  ref={this.phoneInputRef}
                                  onFocus={this.handleFocus}
                                />*/}
                                <>
                                  <ReactPhoneInput
                                    country="us"
                                    inputProps={{
                                      name: "agent_phone",
                                      id: "agent_phone",
                                      maxLength: 20,
                                      required: true,
                                    }}
                                    value={this.state.agent_phone}
                                    onChange={(value) =>
                                      this.handleChange({
                                        target: {
                                          name: "agent_phone",
                                          value: `+${value}`,
                                        },
                                      })
                                    }
                                    specialLabel="Phone Number *"
                                    containerStyle={{ width: "100%" }}
                                    inputStyle={{
                                      width: "100%",
                                      height: "56px",
                                      borderColor:
                                        this.state.errorAgentPhone === "error"
                                          ? "#f44336"
                                          : undefined,
                                    }}
                                    isValid={this.state.errorAgentPhone !== "error"}
                                  />
                                  {this.state.errorAgentPhone === "error" ? (
                                    <small
                                      className="form-text text-muted"
                                      style={{ color: "#f44336" }}
                                    >
                                      Enter a valid phone number
                                    </small>
                                  ) : null}
                                </>
                              </div>

                              <div className="form-group col-md-6 mt-md-0 googleLocation-autocomplete-wrapper">
                                <div
                                  className="nk-block-between-md g-4"
                                  style={{
                                    position: "absolute",
                                    zIndex: 9999,
                                    right: "13px",
                                    top: "-15px",
                                  }}
                                >
                                  <div className="nk-block-head-content"></div>
                                  {this.state.address_autocomplete === "Yes" && (
                                    <div className="nk-block-head-content">
                                      <ul className="nk-block-tools gx-3">
                                        <li>
                                          <a
                                            onClick={this.handleToggle}
                                            className="text-primary fs-11"
                                            style={{
                                              cursor: "pointer",
                                              fontSize: "11px",
                                            }}
                                          >
                                            {toggleButtonText}
                                          </a>
                                        </li>
                                      </ul>
                                    </div>
                                  )}
                                </div>
                                <div>
                                  {this.state.address_autocomplete === "Yes" ? (
                                    useGooglePlaces ? (
                                      <>
                                        <GooglePlacesAutocomplete
                                          apiKey={
                                            process.env
                                              .REACT_APP_ADDRESS_AUTOCOMPLETE_API_KEY
                                          }
                                          selectProps={{
                                            value: this.state.address
                                              ? {
                                                  label: this.state.address,
                                                  value: this.state.address,
                                                }
                                              : null,
                                            onChange: this.handleAddressSelect,
                                            placeholder: this.state.address
                                              ? null
                                              : "Enter your address *",
                                            styles: {
                                              ...errorStyle,
                                              input: (provided) => ({
                                                ...provided,
                                                color: "black",
                                              }),
                                              menu: (provided) => ({
                                                ...provided,
                                                zIndex: "9",
                                              }),
                                            },
                                          }}
                                          id="googleLocation-autocomplete"
                                        />
                                        <p
                                          style={{
                                            fontSize: "0.75rem",
                                            fontWeight: 400,
                                            marginTop: "3px",
                                            color: "#526484",
                                            paddingLeft: "13px",
                                          }}
                                        >
                                          Enter your address here.
                                        </p>
                                      </>
                                    ) : (
                                      <MutextField
                                        required
                                        id="address"
                                        name="address"
                                        type="text"
                                        label="PO Box Address *"
                                        value={this.state.address}
                                        onChange={this.handleChange}
                                        helperText="Enter valid PO Box Address. i.e, PO Box Number, City, State Zip Code"
                                        variant="outlined"
                                        fullWidth
                                        InputLabelProps={{
                                          shrink: true,
                                          required: false,
                                        }}
                                      />
                                    )
                                  ) : (
                                    // address_autocomplete === "No" → show PO Box only
                                    <MutextField
                                      required
                                      id="address"
                                      name="address"
                                      type="text"
                                      label="Address"
                                      value={this.state.address}
                                      onChange={this.handleChange}
                                      helperText="Enter your address"
                                      variant="outlined"
                                      fullWidth
                                      InputLabelProps={{
                                        shrink: true,
                                        required: false,
                                      }}
                                    />
                                  )}
                                </div>
                              </div>

                              <div className="form-group col-md-6">
                                <MutextField
                                  id="address2"
                                  name="address2"
                                  type="text"
                                  inputProps={{ maxLength: 30 }}
                                  label="Address2"
                                  value={this.state.address2}
                                  onChange={this.handleChange}
                                  helperText="Enter the address2 here."
                                  variant="outlined"
                                  fullWidth
                                />
                              </div>

                              <div className="form-group col-md-3">
                                <MutextField
                                  required
                                  id="city"
                                  name="city"
                                  type="text"
                                  inputProps={{ maxLength: 30 }}
                                  label="City"
                                  value={this.state.city}
                                  onChange={this.handleChange}
                                  helperText="Enter the city here."
                                  variant="outlined"
                                  fullWidth
                                  error={this.state.errorAgentCity === "error"}
                                />
                              </div>

                              <div className="form-group col-md-3">
                                <MutextField
                                  required
                                  id="state"
                                  name="state"
                                  type="text"
                                  inputProps={{ maxLength: 30 }}
                                  label="State"
                                  value={this.state.state}
                                  onChange={this.handleChange}
                                  helperText="Enter the state here."
                                  variant="outlined"
                                  fullWidth
                                  error={this.state.errorAgentState === "error"}
                                />
                              </div>

                              <div className="form-group col-md-3">
                                <MutextField
                                  required
                                  id="zip"
                                  name="zip"
                                  type="text"
                                  inputProps={{ maxLength: 30 }}
                                  label="zip"
                                  value={this.state.zip}
                                  onChange={this.handleChange}
                                  helperText="Enter the zip here."
                                  variant="outlined"
                                  fullWidth
                                  error={this.state.errorAgentZip === "error"}
                                />
                              </div>

                              <div className="form-group col-md-3">
                                <Autocomplete
                                  options={this.countryOptions}
                                  getOptionLabel={(option) => option.label}
                                  value={
                                    this.state.country
                                      ? this.countryOptions.find(
                                          (opt) =>
                                            opt.label === this.state.country ||
                                            opt.value === this.state.country,
                                        ) || null
                                      : null
                                  }
                                  onChange={(event, newValue) =>
                                    this.handleChangeCountry(newValue)
                                  }
                                  renderInput={(params) => (
                                    <MutextField
                                      {...params}
                                      required
                                      label="Country"
                                      placeholder="Select a country"
                                      variant="outlined"
                                      fullWidth
                                      error={this.state.errorAgentCountry === "error"}
                                      helperText="Select country"
                                    />
                                  )}
                                />
                              </div>

                              {/* Keep Password & Confirm Password side by side regardless of the
                                  optional Role field shifting the grid. */}
                              <div className="w-100"></div>
                              <div
                                className="form-group col-md-6"
                                style={{ position: "relative" }}
                              >
                                <MutextField
                                  required
                                  id="agent_password"
                                  name="agent_password"
                                  type={
                                    this.state.passwordShown ? "text" : "password"
                                  }
                                  label="Paasword"
                                  value={this.state.agent_password}
                                  inputProps={{ maxLength: 30 }}
                                  onChange={this.handleChange}
                                  helperText=""
                                  variant="outlined"
                                  fullWidth
                                  error={
                                    this.state.errorAgentPassword === "error"
                                  }
                                />
                                <a
                                  style={{
                                    left: "auto",
                                    right: "10px",
                                    top: "41px",
                                    position: "absolute",
                                    cursor: "pointer",
                                  }}
                                  tabIndex="-1"
                                  onClick={this.togglePassword}
                                  className="form-icon form-icon-right passcode-switch"
                                  data-target="password"
                                >
                                  {this.state.passwordShown ? (
                                    <em className="icon ni ni-eye-off"></em>
                                  ) : (
                                    <em className="icon ni ni-eye"></em>
                                  )}
                                </a>
                                <small
                                  className="form-text"
                                  style={{
                                    position: "absolute",
                                    top: "69px",
                                    left: "26px",
                                    color: "#0000008a",
                                    fontSize: "0.75rem",
                                    fontWeight: "400",
                                    fontFamily:
                                      '"Roboto", "Helvetica", "Arial", sans-serif',
                                    maxWidth: "90%",
                                  }}
                                >
                                  Password must be at least 8 characters, with
                                  uppercase, lowercase, number & special
                                  character.
                                </small>
                                <div style={{ marginTop: "45px" }}>
                                  <PasswordStrengthBar
                                    password={this.state.agent_password}
                                  />
                                </div>
                              </div>
                              <div
                                className="form-group col-md-6"
                                style={{ position: "relative" }}
                              >
                                <MutextField
                                  required
                                  id="c_password"
                                  name="c_password"
                                  type={
                                    this.state.confirmPasswordShown
                                      ? "text"
                                      : "password"
                                  }
                                  label="Confirm Password"
                                  value={this.state.c_password}
                                  inputProps={{ maxLength: 30 }}
                                  onChange={this.handleChange}
                                  helperText=""
                                  variant="outlined"
                                  fullWidth
                                  error={this.state.errorCPassword === "error"}
                                />
                                <a
                                  style={{
                                    left: "auto",
                                    right: "10px",
                                    top: "41px",
                                    position: "absolute",
                                    cursor: "pointer",
                                  }}
                                  tabIndex="-1"
                                  onClick={this.toggleConfirmPassword}
                                  className="form-icon form-icon-right passcode-switch"
                                  data-target="password"
                                >
                                  {this.state.confirmPasswordShown ? (
                                    <em className="icon ni ni-eye-off"></em>
                                  ) : (
                                    <em className="icon ni ni-eye"></em>
                                  )}
                                </a>
                                <small
                                  className="form-text"
                                  style={{
                                    position: "absolute",
                                    top: "69px",
                                    left: "26px",
                                    color: "#0000008a",
                                    fontSize: "0.75rem",
                                    fontWeight: "400",
                                    fontFamily:
                                      '"Roboto", "Helvetica", "Arial", sans-serif',
                                    maxWidth: "90%",
                                  }}
                                >
                                  Confirm Password must be at least 8 characters,
                                  with uppercase, lowercase, number & special
                                  character. Confirm Password must match the
                                  Password.
                                </small>
                              </div>

                              <div className="form-group col-md-6">
                                <MutextField
                                  id="account_status"
                                  name="account_status"
                                  select
                                  label="Select Account Status"
                                  value={this.state.account_status}
                                  onChange={this.handleChange}
                                  SelectProps={{
                                    native: true,
                                  }}
                                  helperText="Select the account status here."
                                  variant="outlined"
                                  fullWidth
                                >
                                  <option key="5" value="active">
                                    Active
                                  </option>
                                  <option key="10" value="inactive">
                                    Inactive
                                  </option>
                                </MutextField>
                              </div>

                              <div
                                className="custom-control custom-control-lg custom-checkbox col-lg-3"
                                style={{ padding: 0, marginLeft: "3rem" }}
                              >
                                <div className="form-group">
                                  <input
                                    type="checkbox"
                                    className="custom-control-input"
                                    id="customCheck2"
                                    checked={this.state.notifyCheckBox}
                                    onChange={() => {
                                      const isChecked =
                                        !this.state.notifyCheckBox;
                                      this.setState({
                                        notifyCheckBox: isChecked,
                                      });
                                      // console.log(
                                      //   "Notify Checkbox Checked:",
                                      //   isChecked
                                      // );
                                    }}
                                  />
                                  <label
                                    className="custom-control-label"
                                    htmlFor="customCheck2"
                                  >
                                    Notify Sub Agent Partner
                                  </label>
                                </div>
                              </div>

                              <div style={{ clear: "both" }}></div>
                              <hr />
                              <div className="form-group text-right col-md-12">
                                <button
                                  className="btn btn-lg btn-primary"
                                  type="button"
                                  disabled={this.state.disabled}
                                  onClick={this.formUpdateSubmit}
                                >
                                  Submit
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>

                        {/* </form> */}
                      </div>
                    </div>
                  </div>
                </div>
                {/* EDIT MODAL End */}
                {/* DETAIL MODAL End */}
                <div className="modal fade" tabIndex="-1" id="modalFormSplit">
                  <div
                    className="modal-dialog modal-xl modal-dialog-top"
                    role="document"
                  >
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">
                          {" "}
                          <em className="icon ni ni-edit"></em> Sub Agent Split
                        </h5>
                        <a
                          href="#"
                          className="close"
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          <em className="icon ni ni-cross"></em>
                        </a>
                      </div>

                      <div className="modal-body">
                        {/* Error Start */}

                        <div className="col-lg-12 col-md-12 col-xxl-12">
                          <div
                            id="accordion-2"
                            className="accordion accordion-s3"
                          >
                            <div className="accordion-item">
                              <a
                                href="#"
                                className="accordion-head"
                                data-toggle="collapse"
                                data-target="#accordion-item-2-1"
                              >
                                <h6 className="title">Sub Agent Split</h6>
                                <span className="accordion-icon"></span>
                              </a>
                              <div
                                className="accordion-body collapse show"
                                id="accordion-item-2-1"
                                data-parent="#accordion-2"
                              >
                                <div className="accordion-inner">
                                  {this.state.tableLoaderListing === true ? (
                                    tableLoaderListing()
                                  ) : (
                                    <>
                                      {this.state.splitData ? (
                                        <table className="table">
                                          <thead className="thead-light">
                                            <tr>
                                              <th scope="col">Service</th>
                                              <th scope="col">Sub Agent Split</th>
                                              <th scope="col">Date Added</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {this.state.splitData.map(
                                              (splits, index) => (
                                                <tr key={`index${index}`}>
                                                  <td>{splits[0]}</td>
                                                  <td>{splits[1]}</td>
                                                  <td>{splits[2]}</td>
                                                </tr>
                                              )
                                            )}
                                          </tbody>
                                        </table>
                                      ) : (
                                        <div
                                          className="example-alert"
                                          style={{ marginBottom: "20px" }}
                                        >
                                          <div className="alert alert-pro alert-warning">
                                            <div className="alert-text">
                                              <h4>Warning</h4>
                                              <p>Sub Agent split is not added.</p>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                            {/*<div className="accordion-item">
                              <a
                                href="#"
                                className="accordion-head collapsed"
                                data-toggle="collapse"
                                data-target="#accordion-item-2-2"
                              >
                                <h6 className="title">Update Sub Agent Split</h6>
                                <span className="accordion-icon"></span>
                              </a>
                              <div
                                className="accordion-body collapse"
                                id="accordion-item-2-2"
                                data-parent="#accordion-2"
                              >
                                <div className="accordion-inner">
                                  {this.state.errorMessage !== "" ? (
                                    <div
                                      className="example-alert"
                                      style={{ marginBottom: "20px" }}
                                    >
                                      <div className="alert alert-pro alert-danger">
                                        <div className="alert-text">
                                          <h4>Error</h4>
                                          <p
                                            dangerouslySetInnerHTML={{
                                              __html: this.state.errorMessage,
                                            }}
                                          ></p>
                                        </div>
                                      </div>
                                    </div>
                                  ) : null}
                                  {this.state.successMessage !== "" ? (
                                    <div
                                      className="example-alert"
                                      style={{ marginBottom: "20px" }}
                                    >
                                      <div className="alert alert-pro alert-success">
                                        <div className="alert-text">
                                          <h4>Success</h4>
                                          <p>{this.state.successMessage}</p>
                                        </div>
                                      </div>
                                    </div>
                                  ) : null}
                                  <div style={{ clear: "both" }}></div>
                                  {this.state.servicesData.length > 0 ? (
                                    <>
                                      <form
                                        method="post"
                                        encType="multipart/form-data"
                                      >
                                        <div className="col-lg-12 col-md-12">
                                          <ul className="data-list is-compact">
                                            <li
                                              className="data-item"
                                              style={{
                                                backgroundColor: "#f5f6fa",
                                              }}
                                            >
                                              <div className="data-col">
                                                <div className="data-label">
                                                  Service
                                                </div>
                                                <div
                                                  className="data-value"
                                                  style={{ width: "48%" }}
                                                >
                                                  Select Split
                                                </div>
                                              </div>
                                            </li>
                                            {this.state.servicesData.map(
                                              (didservices, index) => (
                                                <li
                                                  className="data-item"
                                                  key={index}
                                                >
                                                  <div className="data-col">
                                                    <div className="data-label">
                                                      {didservices[1]}
                                                    </div>
                                                    <div
                                                      className="data-value"
                                                      style={{ width: "48%" }}
                                                    >
                                                      <MutextField
                                                        name="agent_split"
                                                        select
                                                        label="Sub Agent Split"
                                                        value={
                                                          this.state.agent_split
                                                        }
                                                        onChange={(e) =>
                                                          this.handleChangeSplit(
                                                            e,
                                                            index
                                                          )
                                                        }
                                                        SelectProps={{
                                                          native: true,
                                                        }}
                                                        helperText="Split is divided in ratio Agent/Sub-agent."
                                                        variant="outlined"
                                                        fullWidth
                                                      >
                                                        <option
                                                          value={`80/20_${didservices[0]}`}
                                                        >
                                                          80/20
                                                        </option>
                                                        <option
                                                          value={`70/30_${didservices[0]}`}
                                                        >
                                                          70/30
                                                        </option>
                                                        <option
                                                          value={`60/40_${didservices[0]}`}
                                                        >
                                                          60/40
                                                        </option>
                                                        <option
                                                          value={`50/50_${didservices[0]}`}
                                                        >
                                                          50/50
                                                        </option>
                                                        <option
                                                          value={`40/60_${didservices[0]}`}
                                                        >
                                                          40/60
                                                        </option>
                                                        <option
                                                          value={`30/70_${didservices[0]}`}
                                                        >
                                                          30/70
                                                        </option>
                                                        <option
                                                          value={`20/80_${didservices[0]}`}
                                                        >
                                                          20/80
                                                        </option>
                                                      </MutextField>
                                                    </div>
                                                  </div>
                                                </li>
                                              )
                                            )}
                                          </ul>
                                        </div>
                                        <div className="form-group text-right col-md-12">
                                          <button
                                            className="btn btn-lg btn-primary"
                                            type="button"
                                            disabled={this.state.disabled}
                                            onClick={this.formSplitUpdate}
                                          >
                                            Submit
                                          </button>
                                        </div>
                                      </form>
                                    </>
                                  ) : null}
                                </div>
                              </div>
                            </div>*/}
                          </div>

                          <div style={{ clear: "both" }}></div>
                          <hr />
                        </div>

                        {/* </form> */}
                      </div>
                    </div>
                  </div>
                </div>
                {/* EDIT MODAL End */}
                {/* Role Sub Assignment Modal START */}
                <div
                  className="modal fade"
                  tabIndex="-1"
                  id="modalSubAgentAssignRole"
                >
                  <div
                    className="modal-dialog modal-xl modal-dialog-top"
                    role="document"
                  >
                    <div className="modal-content">
                      <div className="modal-header">
                        <div
                          className="modal-title"
                          style={{ textAlign: "center", fontSize: "20px" }}
                        >
                          <strong>
                            <em className="icon ni ni-grid-alt"></em>Sub Agent
                            Menu Permissions{" "}
                            <sup>
                              <small className="text-soft">
                                {this.state.rolesAgentName}
                              </small>
                            </sup>
                          </strong>
                        </div>
                        <a
                          href="#"
                          className="close"
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          <em className="icon ni ni-cross"></em>
                        </a>
                      </div>

                      <div className="modal-body text-left">
                        <div className="nk-modal">
                          <div className="nk-modal-text">
                            {this.state.agentRoleLoader === true ? (
                              tableLoader()
                            ) : (
                              <>
                                {this.state.errorMessageAgentRole !== "" ? (
                                  <div
                                    className="example-alert "
                                    style={{ marginBottom: "15px" }}
                                  >
                                    <div className="alert alert-pro alert-danger">
                                      <div className="alert-text">
                                        <h4>Error</h4>
                                        <p>{this.state.errorMessageAgentRole}</p>
                                      </div>
                                    </div>
                                  </div>
                                ) : null}
                                {this.state.successMessageAgentRole !== "" ? (
                                  <div
                                    className="example-alert "
                                    style={{ marginBottom: "15px" }}
                                  >
                                    <div className="alert alert-pro alert-success">
                                      <div className="alert-text">
                                        <h4>Success</h4>
                                        <p>
                                          {this.state.successMessageAgentRole}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                ) : null}

                                <div className="card card-bordered card-preview">
                                  <table className="table table-orders">
                                    <thead className="tb-odr-head">
                                      <tr className="tb-odr-item">
                                        <th
                                          width="35%"
                                          style={{
                                            borderRight: "1px solid #dbdfea",
                                          }}
                                        >
                                          <span className="tb-odr-action">
                                            Roles
                                          </span>
                                        </th>
                                        <th width="65%">
                                          <span className="tb-odr-action">
                                            Sub Roles
                                          </span>
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody className="tb-odr-body">
                                      {this.state.allRoleData &&
                                      this.state.allRoleData.length > 0 ? (
                                        <>
                                          {this.state.allRoleData.map(
                                            (role, index) => (
                                              <tr
                                                className="tb-odr-item"
                                                key={`role${index}`}
                                              >
                                                <td
                                                  style={{
                                                    borderRight:
                                                      "1px solid #dbdfea",
                                                  }}
                                                >
                                                  <FormControlLabel
                                                    control={
                                                      <Checkbox
                                                        checked={this.state.allRoleData.some(
                                                          (item) =>
                                                            item.alt ===
                                                              role.alt &&
                                                            item.isChecked
                                                        )}
                                                        onChange={
                                                          this
                                                            .changedAllRolesRights
                                                        }
                                                        disabled={
                                                          role.parent_role_id ===
                                                          1
                                                        }
                                                        name={role?.id?.toString()}
                                                        color="primary"
                                                      />
                                                    }
                                                    style={{
                                                      marginBottom: "0px",
                                                    }}
                                                    label={role.alt}
                                                  />
                                                </td>
                                                <td
                                                  style={{
                                                    display: "flex",
                                                    flexWrap: "wrap",
                                                    paddingLeft: "16px",
                                                  }}
                                                >
                                                  {this.state.allSubRoleData
                                                    .filter((subRole) => {
                                                      return (
                                                        subRole.role_id ===
                                                        role.id
                                                      );
                                                    })
                                                    .map((subRole, subIndex) => (
                                                      <div
                                                        key={`subRole${subIndex}`}
                                                      >
                                                        <FormControlLabel
                                                          control={
                                                            <Checkbox
                                                              checked={this.state.allSubRoleData.some(
                                                                (item) =>
                                                                  item.alt ===
                                                                    subRole.alt &&
                                                                  item.isChecked
                                                              )}
                                                              onChange={
                                                                this
                                                                  .changedAllSubRolesRights
                                                              }
                                                              name={subRole?.tabdetailid?.toString()}
                                                              color="primary"
                                                            />
                                                          }
                                                          style={{
                                                            marginBottom: "0px",
                                                          }}
                                                          label={subRole.alt}
                                                        />
                                                      </div>
                                                    ))}
                                                </td>
                                              </tr>
                                            )
                                          )}
                                        </>
                                      ) : null}
                                    </tbody>
                                  </table>
                                </div>
                                <div className="nk-modal-action  text-right">
                                  <a
                                    href="#"
                                    className="btn btn-lg btn-mw btn-primary "
                                    onClick={(e) => {
                                      e.preventDefault();
                                      this.handleSubmitRoleCheckbox(
                                        this.state.checkedName,
                                        this.state.checkedEmail
                                      );
                                    }}
                                    disabled={this.state.disableRoleBtn}
                                  >
                                    Save Menu Permissions
                                  </a>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Role Sub Assignment Modal End */}
                {/* New Client Modal Start */}
                <div className="modal fade" tabIndex="-1" id="modalAddNewAgent">
                  <div
                    className="modal-dialog modal-dialog-top modal-xl"
                    role="document"
                  >
                    <div className="modal-content">
                      <a
                        href="#"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <em className="icon ni ni-cross"></em>
                      </a>
                      <div className="modal-header">
                        <h5 className="modal-title">
                          <em
                            className="icon ni ni-user-add"
                            style={{ marginRight: "5px" }}
                          ></em>{" "}
                          Invite New Sub Agent
                        </h5>
                      </div>
                      <div className="modal-body">
                        {this.state.formLoader === true ? (
                          FormLoader()
                        ) : (
                          <div className="row g-4">
                            {this.state.errorMessageInvite !== "" ? (
                              <div className="col-md-12 mb-3">
                                <div
                                  className="example-alert example-alert-revoke"
                                  style={{ marginBottom: "15px" }}
                                >
                                  <div className="alert alert-pro alert-danger">
                                    <div className="alert-text">
                                      <h4>Error</h4>
                                      <p>{this.state.errorMessageInvite}</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ) : null}
                            {this.state.successMessageInvite !== "" ? (
                              <div className="col-md-12 mb-3">
                                <div
                                  className="example-alert example-alert-revoke"
                                  style={{ marginBottom: "15px" }}
                                >
                                  <div className="alert alert-pro alert-success">
                                    <div className="alert-text">
                                      <h4>Success</h4>
                                      <p>{this.state.successMessageInvite}</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ) : null}

                            <div className="col-md-6">
                              <div className="form-group">
                                <div className="form-control-group">
                                  <MutextField
                                    required
                                    id="agent_name"
                                    name="agent_name"
                                    type="text"
                                    label="Full Name"
                                    defaultValue={this.state.agent_name}
                                    inputProps={{ maxLength: 64 }}
                                    onInput={(e) => {
                                      e.target.value = e.target.value.replace(
                                        /[^a-zA-Z\s'.,:\-()|!@]/gi,
                                        ""
                                      );
                                    }}
                                    helperText="Full name of the invite recipient."
                                    onChange={this.handleChange}
                                    variant="outlined"
                                    fullWidth
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <div className="form-control-group">
                                  <MutextField
                                    required
                                    id="agent_email"
                                    name="agent_email"
                                    type="text"
                                    label="Email Address"
                                    defaultValue={this.state.agent_email}
                                    helperText="Email address of the invite recipient."
                                    inputProps={{ maxLength: 100 }}
                                    onChange={this.handleChange}
                                    variant="outlined"
                                    fullWidth
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <div className="form-control-group">
                                  <TextareaAutosize
                                    maxrows={4}
                                    name="invitation_comment"
                                    id="invitation_comment"
                                    aria-label=""
                                    placeholder="Add Comment *"
                                    inputProps={{ maxLength: 500 }}
                                    //maxLength={500}
                                    value={this.state.invitation_comment}
                                    helperText="Maximum 500 characters"
                                    onChange={this.handleChange}
                                    style={{
                                      width: "100%",
                                      height: "100px",
                                      borderColor: "rgba(0, 0, 0, 0.125)",
                                      borderRadius: "4px",
                                      padding: "5px",
                                    }}
                                    variant="outlined"
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-md-12 d-flex justify-content-end">
                              <button
                                type="button"
                                onClick={() => this.saveNewAgent()}
                                className="btn btn-primary"
                                disabled={this.state.disabled}
                              >
                                <span>Send Invite</span>{" "}
                                <em className="icon ni ni-emails"></em>
                              </button>
                            </div>
                            <div className="col-md-12">
                              <div className="example-alert">
                                <div className="alert alert-light">
                                  <ul className="list">
                                    <li>
                                      An email will be dispatched to the provided
                                      email address.
                                    </li>
                                    <li>
                                      This email will contain a secure, tokenized
                                      link for sub agent registration.
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                {/* New Client Modal End */}
                {/* Modal Invitation Comment */}
                <div className="modal fade" tabIndex="-1" id="modalInvitationComment">
                  <div
                    className="modal-dialog modal-xl modal-dialog-top"
                    role="document"
                  >
                    <div className="modal-content">
                      <a
                        href="#"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <em className="icon ni ni-cross"></em>
                      </a>
                      <div className="modal-header">
                        <h5 className="modal-title">Invitation Comments</h5>
                      </div>
                      <div className="modal-body">
                        <p className="text-dark">
                          {this.state.invitation_comment &&
                          this.state.invitation_comment !== ""
                            ? this.state.invitation_comment
                            : "No Comments"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Modal Invitation Comment */}
                {/* MODAL Delete Client START */}
                <div className="modal fade" tabIndex="-1" id="modalDeleteAlert">
                  <div className="modal-dialog" role="document">
                    <div className="modal-content">
                      <a
                        style={{ cursor: "pointer" }}
                        className="close"
                        onClick={() => {
                          this.modalHideDel();
                        }}
                      >
                        <em className="icon ni ni-cross"></em>
                      </a>
                      <div className="modal-body modal-body-lg text-center">
                        <div className="nk-modal">
                          <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-trash bg-success"></em>
                          <h4 className="nk-modal-title">
                            Delete Invited Sub Agent?
                          </h4>
                          {this.state.errorMessageInvite !== "" ? (
                            <div
                              className="example-alert"
                              style={{ marginBottom: "15px" }}
                            >
                              <div className="alert alert-pro alert-danger">
                                <div className="alert-text">
                                  <h4>Error</h4>
                                  <p>{this.state.errorMessageInvite}</p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {this.state.successMessageInvite !== "" ? (
                            <div
                              className="example-alert"
                              style={{ marginBottom: "15px" }}
                            >
                              <div className="alert alert-pro alert-success">
                                <div className="alert-text">
                                  <h4>Success</h4>
                                  <p>{this.state.successMessageInvite}</p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          <div className="nk-modal-text">
                            <div className="caption-text">
                              Are you sure you want to delete this Sub Agent
                              Invitation?
                            </div>
                          </div>
                          <div className="nk-modal-action">
                            <a
                              style={{ cursor: "pointer", color: "white" }}
                              className="btn btn-lg btn-mw btn-primary"
                              onClick={() => {
                                this.modalHideDel();
                              }}
                            >
                              CANCEL
                            </a>
                            {"  "}
                            <button
                              style={{ cursor: "pointer" }}
                              className="btn btn-lg btn-mw btn-danger"
                              onClick={() => {
                                this.deleteInviteAgent();
                              }}
                              disabled={this.state.disabled}
                            >
                              DELETE
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* MODAL Delete Client End */}
                {/* Resend Invitation Modal Start */}
                <div
                  className="modal fade"
                  tabIndex="-1"
                  id="modalresendInvitation"
                >
                  <div className="modal-dialog" role="document">
                    <div className="modal-content">
                      {this.state.successMessageInvite && (
                        <>
                          <a
                            style={{ cursor: "pointer" }}
                            className="close"
                            onClick={() => {
                              this.modalHideResend();
                            }}
                          >
                            <em className="icon ni ni-cross"></em>
                          </a>
                          <div className="modal-body modal-body-lg text-center">
                            <div className="nk-modal">
                              <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-check bg-success"></em>
                              <h4
                                className="nk-modal-title"
                                style={{ fontSize: "1.3rem" }}
                              >
                                {this.state.successMessageInvite}
                              </h4>
                            </div>
                          </div>
                        </>
                      )}
                      {this.state.errorMessageInvite && (
                        <>
                          <a
                            style={{ cursor: "pointer" }}
                            className="close"
                            onClick={() => {
                              this.modalHideResend();
                            }}
                          >
                            <em className="icon ni ni-cross"></em>
                          </a>
                          <div className="modal-body modal-body-lg text-center">
                            <div className="nk-modal">
                              <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-cross bg-danger"></em>
                              <h4
                                className="nk-modal-title"
                                style={{ fontSize: "1.3rem" }}
                              >
                                {this.state.errorMessageInvite}
                              </h4>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                {/* Resend Invitation Modal Ends */}
                {/* Assign Products Modal Start */}
                <div
                  className="modal fade"
                  tabIndex="-1"
                  id="modalAssignProducts"
                >
                  <div
                    className="modal-dialog modal-lg modal-dialog-top"
                    role="document"
                  >
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">
                          <em className="icon ni ni-package"></em> Assign
                          Products{" "}
                          <sup>
                            <small className="text-soft">
                              {this.state.productsAgentName}
                            </small>
                          </sup>
                        </h5>
                        <a
                          href="#"
                          className="close"
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          <em className="icon ni ni-cross"></em>
                        </a>
                      </div>
                      <div className="modal-body">
                        {this.state.productsLoader === true ? (
                          tableLoader()
                        ) : (
                          <>
                            {this.state.errorMessageProducts !== "" ? (
                              <div
                                className="example-alert"
                                style={{ marginBottom: "15px" }}
                              >
                                <div className="alert alert-pro alert-danger">
                                  <div className="alert-text">
                                    <h4>Error</h4>
                                    <p>{this.state.errorMessageProducts}</p>
                                  </div>
                                </div>
                              </div>
                            ) : null}
                            {this.state.successMessageProducts !== "" ? (
                              <div
                                className="example-alert"
                                style={{ marginBottom: "15px" }}
                              >
                                <div className="alert alert-pro alert-success">
                                  <div className="alert-text">
                                    <h4>Success</h4>
                                    <p>{this.state.successMessageProducts}</p>
                                  </div>
                                </div>
                              </div>
                            ) : null}
                            {this.state.productsData &&
                            this.state.productsData.length > 0 ? (
                              <>
                                <div className="card card-bordered card-preview">
                                  <table className="table table-orders">
                                    <thead className="tb-odr-head">
                                      <tr className="tb-odr-item">
                                        <th width="70%">
                                          <span className="tb-odr-action">
                                            Product
                                          </span>
                                        </th>
                                        <th width="30%">
                                          <span className="tb-odr-action">
                                            Assigned
                                          </span>
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody className="tb-odr-body">
                                      {this.state.productsData.map(
                                        (service, index) => (
                                          <tr
                                            className="tb-odr-item"
                                            key={`svc${index}`}
                                          >
                                            <td>{service.service_title}</td>
                                            <td>
                                              <FormControlLabel
                                                control={
                                                  <Checkbox
                                                    checked={
                                                      service.isChecked === true
                                                    }
                                                    onChange={
                                                      this.handleProductCheckbox
                                                    }
                                                    name={String(service.id)}
                                                    color="primary"
                                                  />
                                                }
                                                label=""
                                                style={{ marginBottom: "0px" }}
                                              />
                                            </td>
                                          </tr>
                                        )
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                                <div className="nk-modal-action text-right">
                                  <button
                                    className="btn btn-lg btn-mw btn-primary"
                                    type="button"
                                    onClick={() => this.saveAssignProducts()}
                                    disabled={this.state.disableProductsBtn}
                                  >
                                    Save Products
                                  </button>
                                </div>
                              </>
                            ) : (
                              <div className="example-alert">
                                <div className="alert alert-light">
                                  No products are currently active on your
                                  account. Products the admin assigns to you
                                  can then be assigned to your Sub Agents
                                  here.
                                </div>
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                {/* Assign Products Modal End */}
                {/* Commission Allocation Modal Start */}
                <div
                  className="modal fade"
                  tabIndex="-1"
                  id="modalCommissionAllocation"
                >
                  <div className="modal-dialog modal-dialog-top" role="document">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">
                          <em className="icon ni ni-coins"></em> Commission
                          Allocation{" "}
                          <sup>
                            <small className="text-soft">
                              {this.state.commissionAgentName}
                            </small>
                          </sup>
                        </h5>
                        <a
                          href="#"
                          className="close"
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          <em className="icon ni ni-cross"></em>
                        </a>
                      </div>
                      <div className="modal-body">
                        {this.state.commissionLoader === true ? (
                          tableLoader()
                        ) : (
                          <div className="row g-4">
                            {this.state.errorMessageCommission !== "" ? (
                              <div className="col-md-12">
                                <div className="example-alert">
                                  <div className="alert alert-pro alert-danger">
                                    <div className="alert-text">
                                      <h4>Error</h4>
                                      <p>
                                        {this.state.errorMessageCommission}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ) : null}
                            {this.state.successMessageCommission !== "" ? (
                              <div className="col-md-12">
                                <div className="example-alert">
                                  <div className="alert alert-pro alert-success">
                                    <div className="alert-text">
                                      <h4>Success</h4>
                                      <p>
                                        {this.state.successMessageCommission}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ) : null}
                            <div className="col-md-12">
                              <MutextField
                                required
                                id="commission_percentage"
                                name="commission_percentage"
                                type="number"
                                label="Commission (% of order total)"
                                value={this.state.commission_percentage}
                                onChange={this.handleChange}
                                inputProps={{
                                  step: "0.01",
                                  min: "0",
                                  max: "100",
                                }}
                                helperText={
                                  this.state.commission_main_rate !== null &&
                                  this.state.commission_main_rate !== undefined
                                    ? "Your commission rate is " +
                                      this.state.commission_main_rate +
                                      "%. After assigning " +
                                      (parseFloat(
                                        this.state.commission_percentage
                                      ) || 0) +
                                      "% you keep " +
                                      Math.max(
                                        0,
                                        this.state.commission_main_rate -
                                          (parseFloat(
                                            this.state.commission_percentage
                                          ) || 0)
                                      ).toFixed(2) +
                                      "% on this Sub Agent's orders. Every Sub Agent is allocated independently — your other Sub Agents are not affected, and your own orders always earn the full " +
                                      this.state.commission_main_rate +
                                      "%. Any decimal value is allowed, e.g. 0.1, 2, 5."
                                    : "Percentage of each order total this Sub Agent earns; the amount is deducted from your commission on this Sub Agent's orders only — your own orders are not affected. Any decimal value is allowed, e.g. 0.1, 2, 5."
                                }
                                variant="outlined"
                                fullWidth
                              />
                            </div>
                            <div className="col-md-12 d-flex justify-content-end">
                              <button
                                type="button"
                                className="btn btn-primary"
                                onClick={() => this.saveCommissionAllocation()}
                                disabled={this.state.disableCommissionBtn}
                              >
                                Save Allocation
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                {/* Commission Allocation Modal End */}
              </div>
            </div>
          </div>
        </div>

        {/* Menu Component */}
        <Menu
          anchorEl={this.state.anchorEl}
          open={Boolean(this.state.anchorEl)}
          onClose={this.handleMenuClose}
          keepMounted
          getContentAnchorEl={null}
          disableAutoFocusItem
          disableEnforceFocus
          disableScrollLock
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          PaperProps={{
            style: {
              minWidth: 150,
              width: "auto",
              fontSize: "12px",
              fontWeight: "500",
              color: "#526484",
              lineHeight: "1.3rem",
            },
          }}
        >
          {this.state.menuType === "agents" && (
            <>
              <MenuItem
                onClick={() => {
                  this.editAgentForm(null, {
                    rowData: this.state.selectedRowData,
                  });
                  this.handleMenuClose();
                }}
                disabled={
                  this.props.is_msa_signed === "No" ||
                  this.props.defaultSettings === "missing"
                }
              >
                <em
                  className="icon ni ni-edit"
                  style={{ marginRight: 8 }}
                ></em>
                Edit Sub Agent
              </MenuItem>

              <MenuItem
                onClick={() => {
                  this.openAssignProducts({
                    rowData: this.state.selectedRowData,
                  });
                  this.handleMenuClose();
                }}
                disabled={
                  this.props.is_msa_signed === "No" ||
                  this.props.defaultSettings === "missing"
                }
              >
                <em
                  className="icon ni ni-package"
                  style={{ marginRight: 8 }}
                ></em>
                Assign Products
              </MenuItem>

              <MenuItem
                onClick={() => {
                  this.openCommissionAllocation({
                    rowData: this.state.selectedRowData,
                  });
                  this.handleMenuClose();
                }}
                disabled={
                  this.props.is_msa_signed === "No" ||
                  this.props.defaultSettings === "missing"
                }
              >
                <em
                  className="icon ni ni-coins"
                  style={{ marginRight: 8 }}
                ></em>
                Commission Allocation
              </MenuItem>

              <MenuItem
                onClick={() => {
                  this.subagentAssignRole(null, {
                    rowData: this.state.selectedRowData,
                  });
                  this.handleMenuClose();
                }}
                disabled={
                  this.props.is_msa_signed === "No" ||
                  this.props.defaultSettings === "missing"
                }
              >
                <em
                  className="icon ni ni-grid-alt"
                  style={{ marginRight: 8 }}
                ></em>
                Menu Permissions
              </MenuItem>

              <MenuItem
                onClick={() => {
                  this.subAgentLogin({
                    rowData: this.state.selectedRowData,
                  });
                  this.handleMenuClose();
                }}
                disabled={
                  this.props.is_msa_signed === "No" ||
                  this.props.defaultSettings === "missing"
                }
              >
                <em
                  className="icon ni ni-signin"
                  style={{ marginRight: 8 }}
                ></em>
                Login as Sub Agent
              </MenuItem>
            </>
          )}

          {this.state.menuType === "invitedAgents" && (
            <>
              <MenuItem
                onClick={() => {
                  this.deleteAlert(this.state.selectedRowData[5]);
                  this.handleMenuClose();
                }}
                disabled={
                  this.props.is_msa_signed === "No" ||
                  this.props.defaultSettings === "missing"
                }
              >
                <em
                  className="icon ni ni-trash"
                  style={{ marginRight: 8 }}
                ></em>
                Delete Invite
              </MenuItem>

              <MenuItem
                onClick={() => {
                  this.resendInvite(
                    this.state.selectedRowData[1],
                    this.state.selectedRowData[0],
                    this.state.selectedRowData[3]
                  );
                  this.handleMenuClose();
                }}
                disabled={
                  this.props.is_msa_signed === "No" ||
                  this.props.defaultSettings === "missing"
                }
              >
                <em
                  className="icon ni ni-signin"
                  style={{ marginRight: 8 }}
                ></em>
                Resend Invite
              </MenuItem>
            </>
          )}
        </Menu>
        {/* Menu Component End */}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    defaultSettings: state.settings,
    is_msa_signed: state.is_msa_signed,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addSettings: (payload) => dispatch(addSettings(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(SubAgents);
